exports = module.exports = require("../../node_modules/.store/css-loader@0.27.3/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-container[data-v-614f7ae3]{background:#fff;height:calc(100% - 0px);padding:20px;box-sizing:border-box;overflow:auto}.topForm[data-v-614f7ae3]{display:-ms-flexbox;display:flex}.totalBox[data-v-614f7ae3]{border:1px dashed #ebeef5;padding:20px;margin-top:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.store/css-loader@0.27.3/~/css-loader?minimize!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-614f7ae3","scoped":true,"hasInlineConfig":false}!./~/.store/vue-loader@13.7.3/~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Demo.vue
// module id = 147
// module chunks = 1